import {
  CameraStep,
  RecorderStep,
} from "api/interfaces/reportInterface.interface";
import { chain } from "lodash";
import { MessageDescriptor } from "react-intl";

//BUG [RND-243] GroupBy mergedRecorderId
export const selectedRecorderCountThumbnail = (value: CameraStep[]) => {
  const groupBySelect = chain(value)
    .groupBy((camera) => camera.mergedRecorderId)
    .map((data) => {
      return {
        recorders: data[0].recorderId + "-" + data[0].mergedRecorderId,
        camera: data[0].camera !== undefined ? data[0].camera.length : 0,
      };
    })
    .filter((recorder) => recorder.camera !== 0)
    .value();

  return groupBySelect !== undefined ? groupBySelect.length : 0;
};

export const getThumbnailErrorString = (error: string) => {
  switch (error) {
    case "CameraInvalid":
      return "Camera is Invalid";
    case "CameraOffline":
      return "Camera is Offline";
    case "CameraUnauthorized":
      return "Camera is Unauthorized";
    case "CameraNotRecording":
      return "Camera not Recording";
    case "RecorderNotResponding":
      return "Recorder Not Responding";
    case "RecorderAuthFail":
      return "Recorder Auth Failure";
    default:
      return "Thumbnail Not Available";
  }
};

export const checkSelectRecorder = (
  recorder: RecorderStep
): { isRecorder: boolean; intlMessage?: MessageDescriptor } => {
  if (
    (recorder.systems === undefined || recorder.systems.length === 0) &&
    (recorder.recorderGroupId === undefined ||
      recorder.recorderGroupId.length === 0) &&
    recorder.autoApply === false
  ) {
    return {
      isRecorder: true,
      intlMessage: {
        id: "validateMsg.report.rule.emptyRecorder",
        defaultMessage: "Please select one or more recorders.",
      },
    };
  }
  return {
    isRecorder: false,
  };
};

export const getFormatFilter = (
  value: any,
  data: any[],
  maxLength: number = 6
) => {
  // 모든 timestamp를 가져와서 6개로 제한
  const allTimestamps = new Set<string>();
  data.forEach((series: any) => {
    if (series.data && series.data.length > 0) {
      series.data.forEach((point: any) => {
        if (point.x) {
          allTimestamps.add(point.x);
        }
      });
    }
  });

  const timestamps = Array.from(allTimestamps).sort();
  if (timestamps.length <= maxLength) {
    return value;
  }

  const index = timestamps.indexOf(value);
  
  const step = (timestamps.length - 1) / (maxLength - 1);
  const displayIndices = [];
  
  for (let i = 0; i < maxLength; i++) {
    const targetIndex = Math.round(i * step);
    displayIndices.push(targetIndex);
  }

  if (displayIndices.includes(index)) {
    return value;
  }

  //그외 빈문자열 표기
  return "";
};